<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">班次名称：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">班次简称：</span>
        </div>
        <el-input v-model="formData.shortName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">上班打卡时间：</span>
        </div>
        <el-time-picker v-model="formData.checkInTime" format='HH:mm' value-format="HH:mm" size="small" style="width: 280px" placeholder="上班打卡时间"></el-time-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">下班打卡时间：</span>
        </div>
        <el-time-picker v-model="formData.checkOutTime" format='HH:mm' value-format="HH:mm" size="small" style="width: 280px" placeholder="下班打卡时间"></el-time-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">是否跨天：</span>
        </div>
        <el-switch v-model="isAcross" active-text="是" inactive-text="否"></el-switch>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">休息时间：</span>
        </div>
        <el-time-picker is-range v-model="restTime" format='HH:mm' value-format="HH:mm" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择休息时间" size="small" style="width: 280px" ></el-time-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">提前打卡时间
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">即提前多少小时开始本班次考勤打卡</div>
              <i class="el-icon-question"></i>
            </el-tooltip>：
          </span>
        </div>
        <el-input v-model="formData.beforeHour" size="small" style="width: 280px" >
          <template slot="append">小时</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">最晚打卡时间
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">即允许晚多少小时内可打卡下班</div>
              <i class="el-icon-question"></i>
            </el-tooltip>：
          </span>
        </div>
        <el-input v-model="formData.afterHour" size="small" style="width: 280px" >
          <template slot="append">小时</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">允许迟到时间
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">即多少分钟后记为迟到</div>
              <i class="el-icon-question"></i>
            </el-tooltip>：
          </span>
        </div>
        <el-input v-model="formData.allowedLateMinutes" size="small" style="width: 280px" >
          <template slot="append">分钟</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">严重迟到时间
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">即多少分钟后记为旷工</div>
              <i class="el-icon-question"></i>
            </el-tooltip>：
          </span>
        </div>
        <el-input v-model="formData.severelyLateMinutes" size="small" style="width: 280px" >
          <template slot="append">分钟</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">允许提前下班时间
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">即允许提前多少分钟可打卡下班</div>
              <i class="el-icon-question"></i>
            </el-tooltip>：
          </span>
        </div>
        <el-input v-model="formData.allowBeforeMinutes" size="small" style="width: 280px" >
          <template slot="append">分钟</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">早退计为旷工时间
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">即早退多少分钟计为旷工</div>
              <i class="el-icon-question"></i>
            </el-tooltip>：
          </span>
        </div>
        <el-input v-model="formData.advanceMinutes" size="small" style="width: 280px" >
          <template slot="append">分钟</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">工时配置
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">多少小时计为出勤一天</div>
              <i class="el-icon-question"></i>
            </el-tooltip>：
          </span>
        </div>
        <el-input v-model="formData.workingHours" size="small" style="width: 280px" >
          <template slot="append">小时</template>
        </el-input>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import {bus} from '../../../utils/bus'
  import {api} from '../../api/AttendancePoint'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'attendance-team-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧考勤',
          name: 'attendance-department-manage'
        }, {
          value: '班次管理'
        }],
        mainTitle: '修改班次',
        subheading: '',

        isAcross: false,
        restTime: [],
        formData: {
          name: '',
          shortName: '',
          checkInTime: '',
          checkOutTime: '',
          across: '',
          allowedLateMinutes: '',
          severelyLateMinutes: '',
          beforeHour: '',
          afterHour: '',
          restStartTime: '',
          restEndTime: '',
          allowBeforeMinutes: '',
          advanceMinutes: '',
          workingHours: '',
        },
      }
    },
    created () {
      this.getAttendanceClassByCode()
    },
    methods: {
      toManagementPage () {
        this.$router.push({
          name: 'attendance-frequency-manage'
        })
      },

      // 查询
      getAttendanceClassByCode () {
        this.$axios.get(`${api.getAttendanceClassByCode}/${this.$route.params.id}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              this.formData = res.data.data
              if (this.formData.restStartTime && this.formData.restEndTime) {
                this.restTime = [this.formData.restStartTime, this.formData.restEndTime]
              }
              this.isAcross = this.formData.across === '1'
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 修改
      confirm () {
        if (!this.formData.name) {
          nError('请输入班次名称')
          return false
        }
        if (!this.formData.shortName) {
          nError('请输入班次简称')
          return false
        }
        if (!this.formData.checkInTime) {
          nError('请输入上班打卡时间')
          return false
        }
        if (!this.formData.checkOutTime) {
          nError('请输入下班打卡时间')
          return false
        }
        if (!this.formData.beforeHour) {
          nError('请输入提前打卡时间')
          return false
        }
        if (!this.formData.afterHour) {
          nError('请输入最晚打卡时间')
          return false
        }
        if (!this.formData.workingHours) {
          nError('请输入工时配置')
          return false
        }
        this.formData.across = this.isAcross ? '1' : '0'
        if (this.restTime) {
          this.formData.restStartTime = this.restTime[0] || ''
          this.formData.restEndTime = this.restTime[1] || ''
        } else {
          this.formData.restStartTime = ''
          this.formData.restEndTime = ''
        }
        this.$axios.post(api.updateAttendanceClass, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toManagementPage()
            }
          })
          .catch(errorHandler('修改失败'))
      },

      cancel () {
        this.toManagementPage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 190px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
  .el-date-editor .el-range-separator {
    padding: 0;
  }
</style>




// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendanceFrequency/AttendanceFrequencyModify.vue